import React from 'react';
import { formatTodayWithWeekdayInAppTimeZone } from "../utils/appDateTime";

function CurrentDateDisplay() {
  const formattedDate = formatTodayWithWeekdayInAppTimeZone();

  return (
    <React.Fragment>
      {formattedDate}
    </React.Fragment>
  );
}

export default CurrentDateDisplay;
